module.exports = __webpack_public_path__ + "static/media/city-seattle7.039ca50a.png";